module.exports = __webpack_public_path__ + "img/vetting.hod.hod_payment_frequency.448b591a.jpg";